"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.MsgType = exports.Message = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _react = _interopRequireWildcard(require("react"));
var _clsx = _interopRequireDefault(require("clsx"));
var _getPrefixCls = require("../../utils/getPrefixCls");
var _ButtonGroup = require("../ButtonGroup");
var _useTracking3 = require("../../hooks/useTracking");
var _RichText = require("../RichText");
var _reactSvg = require("react-svg");
var _arrow_down = _interopRequireDefault(require("../../assets/images/arrow_down.svg"));
function _getRequireWildcardCache(nodeInterop) {
  if (typeof WeakMap !== "function") return null;
  var cacheBabelInterop = new WeakMap();
  var cacheNodeInterop = new WeakMap();
  return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) {
    return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
  })(nodeInterop);
}
function _interopRequireWildcard(obj, nodeInterop) {
  if (!nodeInterop && obj && obj.__esModule) {
    return obj;
  }
  if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
    return {
      default: obj
    };
  }
  var cache = _getRequireWildcardCache(nodeInterop);
  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }
  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
  for (var key in obj) {
    if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }
  newObj.default = obj;
  if (cache) {
    cache.set(obj, newObj);
  }
  return newObj;
}
var MsgType;
exports.MsgType = MsgType;
(function (MsgType) {
  MsgType[MsgType["default"] = 0] = "default";
  MsgType[MsgType["changeOrder"] = 1] = "changeOrder";
})(MsgType || (exports.MsgType = MsgType = {}));
var Message = function Message(props) {
  var _buttonGroup$buttons;
  var _id = props._id,
    className = props.className,
    content = props.content,
    options = props.options,
    buttonGroup = props.buttonGroup,
    shouldHandleDateVariable = props.shouldHandleDateVariable,
    jumpNodeMap = props.jumpNodeMap,
    jumpOrderShortCutMap = props.jumpOrderShortCutMap,
    disableSpecialLink = props.disableSpecialLink,
    linkTrackingData = props.linkTrackingData,
    msgType = props.msgType,
    onImageError = props.onImageError,
    onImageLoad = props.onImageLoad,
    onCollapseClick = props.onCollapseClick,
    previewMockData = props.previewMockData,
    handleVariableShow = props.handleVariableShow,
    handleVariableHide = props.handleVariableHide,
    richTextMsgTrackingData = props.richTextMsgTrackingData,
    isUIOptimisationButton = props.isUIOptimisationButton,
    isUIOptimisationTable = props.isUIOptimisationTable;
  var _useState = (0, _react.useState)(props.collapse),
    _useState2 = (0, _slicedToArray2.default)(_useState, 2),
    collapse = _useState2[0],
    setCollapse = _useState2[1];
  var showButtonGroup = buttonGroup === null || buttonGroup === void 0 ? void 0 : (_buttonGroup$buttons = buttonGroup.buttons) === null || _buttonGroup$buttons === void 0 ? void 0 : _buttonGroup$buttons.filter(function (btn) {
    return !btn.hidden;
  }).length;
  var _useTracking = (0, _useTracking3.useTracking)(props),
    trackingImpressionProps = _useTracking.trackingImpressionProps;
  var _useTracking2 = (0, _useTracking3.useTracking)({
      trackingData: props.collapseTrackingData
    }),
    tracker = _useTracking2.tracker,
    trackingClick = _useTracking2.trackingClick,
    collapseTrackingImpressionProps = _useTracking2.trackingImpressionProps;
  return /*#__PURE__*/_react.default.createElement("div", (0, _extends2.default)({
    className: (0, _clsx.default)((0, _getPrefixCls.getPrefixCls)('message'), className)
  }, trackingImpressionProps), /*#__PURE__*/_react.default.createElement(_RichText.RichText, {
    className: (0, _clsx.default)((0, _getPrefixCls.getPrefixCls)('message-content'), 'message-context'),
    content: content,
    options: options,
    shouldHandleDateVariable: shouldHandleDateVariable,
    jumpNodeMap: jumpNodeMap,
    jumpOrderShortCutMap: jumpOrderShortCutMap,
    richTextMsgTrackingData: richTextMsgTrackingData,
    previewMockData: previewMockData,
    disableSpecialLink: disableSpecialLink,
    linkTrackingData: linkTrackingData,
    msgType: msgType,
    onImageError: onImageError,
    onImageLoad: onImageLoad,
    handleVariableShow: handleVariableShow,
    handleVariableHide: handleVariableHide,
    isUIOptimisationButton: isUIOptimisationButton,
    isUIOptimisationTableModal: isUIOptimisationTable
  }), collapse ? /*#__PURE__*/_react.default.createElement("div", collapseTrackingImpressionProps, /*#__PURE__*/_react.default.createElement(_reactSvg.ReactSVG, {
    src: _arrow_down.default,
    onClick: function onClick() {
      trackingClick && tracker.click(trackingClick);
      onCollapseClick === null || onCollapseClick === void 0 ? void 0 : onCollapseClick();
      setCollapse(false);
    },
    className: (0, _getPrefixCls.getPrefixCls)('message-collapse-button')
  })) : showButtonGroup ? /*#__PURE__*/_react.default.createElement(_ButtonGroup.ButtonGroup, (0, _extends2.default)({
    _id: _id,
    className: (0, _getPrefixCls.getPrefixCls)('message-buttons')
  }, buttonGroup)) : null);
};
exports.Message = Message;